module.exports = {
  NODE_ENV: '"production"',
  ANALYTICS_ID: '"UA-129739269-1"',
  EXPORT_DATA_URL:
    '"https://us-central1-pollscape-d2b4b.cloudfunctions.net/exportData"',
  DOMAIN: '"pollscape.web.app"',
};



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 123
// module chunks = 10